module.exports = __webpack_public_path__ + "static/app-6c70bed87c7924fd151ecfb7c1d953fc.png";